// Recovered leads may contain nulls, which fail yup's non-nullable type checks with raw error messages
export const stripNullValues = (value) => {
  if (Array.isArray(value)) {
    return value.map(stripNullValues);
  }
  if (value && typeof value === 'object') {
    return Object.fromEntries(
      Object.entries(value)
        .filter(([, item]) => item !== null)
        .map(([key, item]) => [key, stripNullValues(item)]),
    );
  }
  return value;
};
